import { useState } from "react";
import { Link } from "react-router-dom";
import { SectionEyebrowStyles } from "../components/landing/SectionEyebrow";
import { SaccoHero } from "../components/saccos/SaccoHero";
import { SaccoProblem } from "../components/saccos/SaccoProblem";
import { SaccoHowItWorks } from "../components/saccos/SaccoHowItWorks";
import { SaccoOutcomes } from "../components/saccos/SaccoOutcomes";
import { SaccoFramework } from "../components/saccos/SaccoFramework";
import { SaccoPhases } from "../components/saccos/SaccoPhases";
import { SaccoBusinessCase } from "../components/saccos/SaccoBusinessCase";
import { SaccoDemoForm } from "../components/saccos/SaccoDemoForm";
import { SaccoShareStrip } from "../components/saccos/SaccoShareStrip";

export default function Saccos() {
  const [hours, setHours] = useState("");
  return (
    <div className="min-h-screen bg-white text-neutral-900" style={{ fontFamily: "Manrope, sans-serif" }} data-testid="saccos-page">
      <SectionEyebrowStyles />
      <SaccoHero />
      <SaccoProblem />
      <SaccoHowItWorks />
      <SaccoOutcomes />
      <SaccoFramework />
      <SaccoPhases />
      <SaccoBusinessCase hours={hours} onHoursChange={setHours} />
      <SaccoDemoForm manualHours={hours} />
      <SaccoShareStrip />
      <footer className="border-t border-neutral-200 px-5 py-8 text-center text-xs text-neutral-500" data-testid="sacco-footer">
        © {new Date().getFullYear()} Clinq Africa · <Link to="/privacy-policy" className="hover:text-[#0A8B85]">Privacy policy</Link> · <Link to="/terms" className="hover:text-[#0A8B85]">Terms</Link>
      </footer>
    </div>
  );
}
